import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-2M8WCYMK6L';

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
        page_location: window.location.href,
        send_to: GA_MEASUREMENT_ID,
      });
    }
  }, [location]);

  return null;
};

export default RouteTracker;